import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../theme/palette';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      flexDirection: 'column',
      gap: '20px'
    },
    container: {
      height: '100%',
      maxHeight: '250px',
      '& > div': {
        height: '100%',
        maxHeight: '250px'
      }
    },
    tableResult: {
      margin: '0',
      color: palette.text.white,
      fontWeight: 700,
      display: 'flex',
      gap: '10px'
    },
    title: {
      display: 'flex',
      gap: '10px',
      alignItems: 'flex-start',
      '& h2': {
        fontSize: '1rem',
        fontFamily: 'Montserrat'
      }
    },
    emoji: {
      width: '20px'
    },
    itemsContainer: {
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      gap: '40px',
      paddingTop: '20px'
    },
    itemTitle: {
      position: 'absolute',
      top: '10px',
      left: 0,
      display: 'flex',
      justifyContent: 'center',
      width: '100%'
    },
    item: {
      width: '50px'
    },
    wrapper: {
      display: 'grid',
      gridTemplateColumns: 'repeat(5, 1fr)',
      gridAutoRows: 'minmax(50px, 50px)',
      width: '200px',
      height: '200px',
      paddingTop: '10px'
    },
    placed: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '40px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
